"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (x) {
    var secsAway = x * 60 * 60 * 24;
    return Math.floor(Date.now() / 1000) + secsAway;
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/xDayEpoch.js
// module id = 1
// module chunks = 0